export const WIDTH_DIFF_THRESHOLD = 20
